import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  UFEditor,
  UFInput,
  UFInputNumber,
  UFSwitch,
} from "../../../components/Common/Fields/Input"
import LoadingButton from "../../../components/Common/LoadingButton"

import { fetchPrefix, postPrefix } from "../../../services/Settings/settings"
import { useSelector } from "react-redux"
import moment from "moment"
import NoOfDigits from "../../../components/Common/chooseFields/noOfDigits"
import Switch from "react-switch"

const schema = yup.object().shape({})

const Prefix = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Prefix${companyname ? ` | ${companyname}` : "MEP -Hub"}`
  const navigate = useNavigate()

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [isLoading, setIsLoading] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const [fetchData, setFetchData] = useState(0)
  const [toggleState, setToggleState] = useState({
    year: false,
    month: false,
    yearly_reset: false,
    mannual_override: false,
    monthly_reset: false,
  })

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      prefixes: [
        {
          prefix: "",
          no_of_digits: 0,
          year: 0,
          month: 0,
          yearly_reset: 0,
          monthly_reset: 0,
          mannual_override: 0,
        },
      ],
    },
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { fields: prefixFields } = useFieldArray({
    control,
    name: "prefixes",
  })

  const handleRegistration = async data => {
    console.log(`data`, data)

    const invalidEntries = data?.prefixes?.filter(
      item => item.yearly_reset && !item.year
    )

    const invalidMonthEntries = data?.prefixes?.filter(
      item => item.monthly_reset && !item.month
    )

    if (invalidEntries?.length > 0) {
      toastError("If 'Yearly Reset' is enabled, 'Year' must also be enabled.")
      return
    }
    if (invalidMonthEntries?.length > 0) {
      toastError("If 'Monthly Reset' is enabled, 'Month' must also be enabled.")
      return
    }

    const postArr = data?.prefixes?.map(dt => ({
      prefix: dt?.prefix,
      no_of_digits: dt?.no_of_digits,
      year: dt?.year ? 1 : 0,
      month: dt?.month ? 1 : 0,
      yearly_reset: dt?.yearly_reset ? 1 : 0,
      monthly_reset: dt?.monthly_reset ? 1 : 0,
      mannual_override: dt?.mannual_override ? 1 : 0,
      model_name: dt?.model_name,
      id: dt?.id,
    }))

    // for (const key in data) {
    //   const found = fetchData.find(item => item.model_name === key)
    //   if (found) {
    //     data[found.id] = data[key]
    //     delete data[key]
    //   } else {
    //     delete data[key]
    //   }
    // }
    try {
      setIsLoading(true)
      const updateDepartment = await postPrefix({
        ...postArr,
      })
      setRefresh(refresh + 1)
      toastSuccess(updateDepartment?.messages?.[0]?.message)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const handleFetchPrefix = async () => {
      const response = await fetchPrefix()
      setFetchData(response?.prefixes)
      // response?.prefixes?.map(dt => setValue(dt?.model_name, dt?.prefix))

      const prefixArr = response?.prefixes?.map(dt => ({
        prefix: dt?.prefix,
        model_name: dt?.model_name,
        display_name: dt?.display_name,
        no_of_digits: dt?.no_of_digits,
        year: dt?.year,
        month: dt?.month,
        yearly_reset: dt?.yearly_reset,
        monthly_reset: dt?.monthly_reset,
        mannual_override: dt?.mannual_override,
        id: dt?.id,
      }))
      reset({ prefixes: prefixArr })
    }

    handleFetchPrefix()
  }, [refresh])

  const currYear = moment().format("YYYY")
  const currMonth = moment().format("MM")

  const generateZeros = count => {
    return "0".repeat(count)
  }

  // const fy = loggedUser?.finance?.match(/\d+/)[0]

  const fy = `${currYear}${currMonth}`

  useEffect(() => {
    const prefixes = watch("prefixes") || []
    setToggleState({
      year: prefixes.every(item => item.year),
      month: prefixes.every(item => item.month),
      yearly_reset: prefixes.every(item => item.yearly_reset),
      monthly_reset: prefixes.every(item => item.monthly_reset),
      mannual_override: prefixes.every(item => item.mannual_override),
    })
  }, [watch("prefixes")])

  // const handleToggleColumn = (field, value) => {
  //   const updated = getValues("prefixes").map(item => ({
  //     ...item,
  //     [field]: value,
  //   }))
  //   reset({ prefixes: updated })
  // }

  const handleToggleColumn = (field, value) => {
    const updated = getValues("prefixes").map(item => {
      let updatedItem = { ...item, [field]: value }

      const dependencies = {
        yearly_reset: "year",
        monthly_reset: "month",
      }

      // If the toggled field has a dependent field
      if (dependencies[field]) {
        updatedItem[dependencies[field]] = value ? 1 : 0
      }

      return updatedItem
    })

    reset({ prefixes: updated })
  }

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name?.includes("yearly_reset")) {
        const indexMatch = name.match(/prefixes\.(\d+)\.yearly_reset/)
        if (indexMatch) {
          const index = Number(indexMatch[1])
          const yearlyResetValue = value?.prefixes?.[index]?.yearly_reset

          // If yearly_reset is checked (true/1), then ensure year is also true
          if (yearlyResetValue) {
            setValue(`prefixes.${index}.year`, 1)
          }
        }
      }
      if (name?.includes("monthly_reset")) {
        const indexMatch = name.match(/prefixes\.(\d+)\.monthly_reset/)
        if (indexMatch) {
          const index = Number(indexMatch[1])
          const monthlyResetValue = value?.prefixes?.[index]?.monthly_reset

          // If monthly_reset is checked (true/1), then ensure year is also true
          if (monthlyResetValue) {
            setValue(`prefixes.${index}.month`, 1)
          }
        }
      }
    })

    return () => subscription.unsubscribe()
  }, [watch, setValue])

  return (
    <React.Fragment>
      <div className="page-content tnt-scope prefix-page">
        <div className="container-fluid">
          <FormProvider {...methods}>
            <Form
              id={`general-setting-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between me-2">
                  <Breadcrumbs
                    title="Developer"
                    breadcrumbObject={[
                      { title: "Developer", link: "/developer" },
                      { title: "Numbering & Prefixes", link: "/developer/prefixes" },
                    ]}
                  />
                  <LoadingButton
                    form={`general-setting-form`}
                    color={"primary"}
                    loading={isLoading}
                    disabled={isLoading}
                    className={"px-2 mb-3 me-1 btn btn-primary"}
                    type="submit"
                  >
                    Update
                  </LoadingButton>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="">
                    <Row className="mb-4 mt-2">
                      <Col lg={12} className="scroll-of-perfix">
                        <table className="estimation-table mb-4">
                          <thead>
                            <tr>
                              <th>Sections</th>
                              <th>Prefix</th>
                              <th>No of Digit</th>
                              <th>
                                <div className="d-flex align-items-center gap-2">
                                  Year{" "}
                                  <Switch
                                    checked={toggleState.year}
                                    onChange={checked =>
                                      handleToggleColumn(
                                        "year",
                                        checked ? 1 : 0
                                      )
                                    }
                                    height={18}
                                    width={36}
                                    onColor="#00D592"
                                    offColor="#CBD5E1"
                                    activeBoxShadow="0 0 1px 1px rgba(0,0,0,0.06)"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                  />
                                </div>
                              </th>
                              <th>
                                <div className="d-flex align-items-center gap-2">
                                  Month
                                  <Switch
                                    checked={toggleState.month}
                                    onChange={checked =>
                                      handleToggleColumn(
                                        "month",
                                        checked ? 1 : 0
                                      )
                                    }
                                    height={18}
                                    width={36}
                                    onColor="#00D592"
                                    offColor="#CBD5E1"
                                    activeBoxShadow="0 0 1px 1px rgba(0,0,0,0.06)"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                  />
                                </div>
                              </th>
                              <th>
                                <div className="d-flex align-items-center gap-2">
                                  Yearly reset
                                  <Switch
                                    checked={toggleState.yearly_reset}
                                    onChange={checked =>
                                      handleToggleColumn(
                                        "yearly_reset",
                                        checked ? 1 : 0
                                      )
                                    }
                                    height={16}
                                    width={36}
                                    onColor="#00D592"
                                    offColor="#CBD5E1"
                                    activeBoxShadow="0 0 1px 1px rgba(0,0,0,0.06)"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                  />
                                </div>
                              </th>
                              <th>
                                <div className="d-flex align-items-center gap-2">
                                  Monthly reset
                                  <Switch
                                    checked={toggleState.monthly_reset}
                                    onChange={checked =>
                                      handleToggleColumn(
                                        "monthly_reset",
                                        checked ? 1 : 0
                                      )
                                    }
                                    height={16}
                                    width={36}
                                    onColor="#00D592"
                                    offColor="#CBD5E1"
                                    activeBoxShadow="0 0 1px 1px rgba(0,0,0,0.06)"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                  />
                                </div>
                              </th>
                              <th>
                                <div className="d-flex align-items-center gap-2">
                                  Manual override
                                  <Switch
                                    checked={toggleState.mannual_override}
                                    onChange={checked =>
                                      handleToggleColumn(
                                        "mannual_override",
                                        checked ? 1 : 0
                                      )
                                    }
                                    height={18}
                                    width={36}
                                    onColor="#00D592"
                                    offColor="#CBD5E1"
                                    activeBoxShadow="0 0 1px 1px rgba(0,0,0,0.06)"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                  />
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {fetchData ? (
                              prefixFields?.map((dt, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="d-flex">
                                      <div className="fw-bold text-muted">
                                        {dt?.display_name}
                                      </div>{" "}
                                      <div className="ps-1 fs-12 text-muted pb-0 mt-auto">
                                        ({watch(`prefixes.${index}.prefix`)}
                                        {watch(`prefixes.${index}.year`)
                                          ? currYear
                                          : ""}
                                        {watch(`prefixes.${index}.month`)
                                          ? currMonth
                                          : ""}
                                        {generateZeros(
                                          watch(
                                            `prefixes.${index}.no_of_digits`
                                          )
                                        )}
                                        )
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <UFInput
                                      control={control}
                                      placeholder="Enter Prefix"
                                      name={`prefixes.${index}.prefix`}
                                      invalid={
                                        !!errors.prefixes?.[index]?.prefix
                                      }
                                    />
                                  </td>
                                  <td>
                                    <UFInputNumber
                                      control={control}
                                      placeholder="Enter No of Digits"
                                      name={`prefixes.${index}.no_of_digits`}
                                      maxNum={50}
                                    />
                                  </td>
                                  <td>
                                    <UFSwitch
                                      control={control}
                                      placeholder="Enter Prefix"
                                      name={`prefixes.${index}.year`}
                                    />
                                  </td>
                                  <td>
                                    <UFSwitch
                                      control={control}
                                      placeholder="Enter Prefix"
                                      name={`prefixes.${index}.month`}
                                      invalid={!!errors.month}
                                    />
                                  </td>
                                  <td>
                                    <UFSwitch
                                      control={control}
                                      placeholder="Enter Prefix"
                                      name={`prefixes.${index}.yearly_reset`}
                                      invalid={!!errors.yearly_reset}
                                    />
                                  </td>
                                  <td>
                                    <UFSwitch
                                      control={control}
                                      placeholder="Enter Prefix"
                                      name={`prefixes.${index}.monthly_reset`}
                                      invalid={!!errors.monthly_reset}
                                    />
                                  </td>
                                  <td>
                                    <UFSwitch
                                      control={control}
                                      placeholder="Enter Prefix"
                                      name={`prefixes.${index}.mannual_override`}
                                      invalid={!!errors.mannual_override}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </table>
                      </Col>
                      {/* {fetchData &&
                        fetchData?.map((dt, index) => (
                          <Col sm={3}>
                            <FormGroup className="mb-4">
                              <Label>
                                {dt?.model_name}
                                <span className="mandatory">*</span>
                              </Label>
                              <UFInput
                                control={control}
                                placeholder="Enter Prefix"
                                name={dt?.model_name}
                                invalid={!!errors.dt?.model_name}
                                nonEditableValueLast={fy}
                                className="prefix-border"
                              />
                              <FormFeedback invalid>
                                {errors.dt?.model_name?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        ))} */}
                    </Row>
                  </Row>
                </Card>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Prefix
